module.exports = __webpack_public_path__ + "img/no_ubicados.472c298d.svg";